import React from "react";
import { StarRating } from "../../../components";
import { StarRating as StarRatingType } from "../../../@types";

interface StarRatingListItemProps {
  label: string;
  starRating?: StarRatingType;
  planYear: string;
}

const StarRatingListItem: React.FunctionComponent<StarRatingListItemProps> = ({
  label,
  starRating,
  planYear,
  ...props
}) => {
  return (
    <li
      className="StarRatingListItem"
      role="listitem"
      data-testid="star-rating-list-item"
      {...props}
    >
      <span className="ds-u-margin-bottom--1 ds-u-margin-right--2 ds-u-md-margin-bottom--0">
        {label}
      </span>
      <StarRating stars={starRating} includeLabel={false} planYear={planYear} />
    </li>
  );
};

export default StarRatingListItem;
